import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ModelAccess } from '@simlab/matterport/api';
import {
  ApartmentAccessTokenResponse,
  AuthorizeResponse,
  UserAccessTokenResponse
} from '@simOn/matterport/auth/models';
import { ProviderConnectionsStatus } from '@simOn/provider/connection/models';
import { API_URL } from '@simOn/utils/tokens';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MatterportOauthApiService {
  private readonly http = inject(HttpClient);
  private readonly _apiUrl = inject(API_URL);

  isAuthorized$(): Observable<boolean> {
    return this.http.get<boolean>(`${this._apiUrl}/MatterportUsers/IsUserAuthorized`);
  }

  getUserAccessToken$(): Observable<UserAccessTokenResponse> {
    return this.http.get<UserAccessTokenResponse>(`${this._apiUrl}/MatterportUsers/GetUserAccessToken`);
  }

  logout$(): Observable<void> {
    return this.http.get<void>(`${this._apiUrl}/MatterportUsers/LogoutUser`);
  }

  authorize$(returnUrl: string): Observable<AuthorizeResponse> {
    return this.http.post<AuthorizeResponse>(`${this._apiUrl}/MatterportUsers/GetUserAuthorizationUrl`, { returnUrl });
  }

  updateToken$(code: string, tokenDescription: string): Observable<void> {
    return this.http.post<void>(`${this._apiUrl}/MatterportUsers/CreateUserToken`, { code, tokenDescription });
  }

  getScanModelAccess$(scanId: string): Observable<ModelAccess> {
    return this.http
      .get(`${this._apiUrl}/MatterportModel/GetScanModelAccess?ScanId=${scanId}`, {
        responseType: 'text'
      })
      .pipe(map((response: string) => <ModelAccess>response));
  }
  /** The backend refreshes the token before answering, so the returned token is valid at response time. */
  getMatterportApartmentAccessToken(): Observable<ApartmentAccessTokenResponse> {
    return this.http.get<ApartmentAccessTokenResponse>(`${this._apiUrl}/Matterport/GetApartmentAccessToken`);
  }

  getProviderConnectionStatus$(): Observable<ProviderConnectionsStatus> {
    const params = new HttpParams().set('providerType', 'SCAN').set('scanProvider', 'MATTERPORT');
    return this.http.get<ProviderConnectionsStatus>(`${this._apiUrl}/Matterport/GetProviderConnectionStatus`, {
      params
    });
  }
}
